import { ClockIcon } from "@heroicons/react/24/outline";
import { CalendarIcon, StarIcon } from "@heroicons/react/24/solid";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import { motion } from "framer-motion";
import * as React from "react";
import { Button } from "./ui/button";
import Image from "next/image";
import mixpanel from "@/utils/mixpanel";

export default function BootcampCard({ bootcamp, ...props }: any) {
  const router = useRouter();
  let activeBatch: any;

  function getStartDate(batch: any) {
    for (let i = 0; i < batch?.length; i++) {
      if (batch[i]?.active) {
        activeBatch = batch[i];
        const endDateTime: any = new Date(batch[i]?.endDateTime);
        const startDateTime: any = new Date(batch[i]?.startDateTime);
        const duration = Math.floor(
          Math.abs(endDateTime - startDateTime) / (1000 * 60 * 60 * 24)
        );
        return {
          startDateTime: dayjs(batch[i]?.startDateTime),
          duration: duration,
        };
      }
    }
    return { startDateTime: dayjs(), duration: 1 };
  }

  const rating = bootcamp?.teacher?.achievements?.split(";")[0];
  const students = bootcamp?.teacher?.achievements?.split(";")[2];
  const starArray = [1, 2, 3, 4, 5];

  const startDateInfo = getStartDate(bootcamp?.Batches);

  return (
    <motion.div
      {...props}
      className="h-full flex md:max-w-[500px] w-full mx-auto bg-white flex-col gap-2 rounded-lg shadow-[0_0px_7.596px_0px_rgba(190,190,190,0.4)] p-5 max-xl:p-3 font-lato cursor-pointer"
      onClick={() => {
        router.push(`/bootcamps/${bootcamp?.slug}`);
        mixpanel.track("view_details_bootcamp", {
          bootcamp: bootcamp?.title,
        });
      }}
    >
      <Image
        width={366}
        height={206}
        src={bootcamp?.coverImage || "/common/fallback-cover.webp"}
        alt="thumbnail"
        className="rounded-md w-full object-cover shadow-[0_0.9px_3.6px_0px_rgba(0,0,0,0.06)]"
      />
      <div className="flex justify-between items-center w-full max-xl:text-xs pb-2 border-b-2 border-[#ACACAC7A] border-dotted font-semibold">
        <div className="flex items-center gap-1">
          <CalendarIcon className="w-4 h-4" />
          <p className="text-sm">
            {startDateInfo?.startDateTime?.format("DD MMMM")} (
            {startDateInfo?.startDateTime?.format("dddd")})
          </p>
        </div>
        <div className="flex items-center gap-1">
          <ClockIcon className="w-4 h-4 text-[#0A2133]" />
          <p className="text-sm">
            {startDateInfo?.duration}{" "}
            {startDateInfo?.duration > 1 ? "days" : "day"}
          </p>
        </div>
      </div>

      <div className="flex justify-between items-center w-full max-xl:text-xs font-semibold">
        <div className="flex gap-1 bg-[#9A70261A] rounded-full px-3 py-0.5">
          {bootcamp?.categories?.length > 0 ? (
            bootcamp?.categories?.map((category: any, index: number) => (
              <React.Fragment key={category?.id}>
                <p className="text-sm text-[#9A7026]">{category.name}</p>
                {bootcamp?.categories?.length > 1 &&
                  index !== bootcamp?.categories?.length - 1 && (
                    <p className="text-sm text-[#9A7026]"> | </p>
                  )}
              </React.Fragment>
            ))
          ) : (
            <p className="text-sm text-[#9A7026]">Spirituality</p>
          )}
        </div>
        <div className="flex justify-center items-center gap-1">
          <div className="flex justify-center items-center">
            {rating && rating != "null"
              ? starArray.map((stars: number, index: number) => {
                  if (stars <= rating) {
                    return (
                      <StarIcon
                        key={index}
                        className="w-4 h-4 text-[#9A7026]"
                      />
                    );
                  } else {
                    return (
                      <StarIcon
                        key={index}
                        className="w-4 h-4 text-[#9A702666]"
                      />
                    );
                  }
                })
              : starArray.map((stars, index) => (
                  <StarIcon key={index} className="w-4 h-4 text-[#9A7026]" />
                ))}
          </div>
          <p className="text-sm">
            {rating && rating != "null" ? rating : 5} (
            {parseInt(students) > 1000
              ? `${Math.floor(parseInt(students) / 1000)}k+`
              : "10k+"}
            )
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-between h-full">
        <h4 className="font-semibold md:text-lg w-[300px] multiline-ellipsis">
          {bootcamp?.title}
        </h4>
        <div className="flex justify-between items-center w-full">
          <div className="flex gap-1 items-center relative">
            <h4 className="text-[#9A7026] font-semibold text-lg">
              {`₹${bootcamp?.discountedPrice?.toLocaleString()}`}
            </h4>
            <p className="flex flex-col justify-center text-[#606060] text-sm line-through">
              {`₹${bootcamp?.price?.toLocaleString()}`}
            </p>
          </div>
          <Button
            size={"sm"}
            className="rounded font-bold px-6 py-1.5"
            onClick={() => {
              router.push(`/bootcamps/${bootcamp?.slug}`);
            }}
          >
            Register Now
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
